import { ActionState } from '@colonist/game-states';
export class CurrentStateValidator {
    get currentState() {
        return this._currentState;
    }
    // WARNING! This architecture is fragile. This only works because the base game is force setting currentTurnPlayerColor until the refactor is
    // done. This is silently coupled to CurrentStateControllerDefault.setCurrentTurnPlayer
    get currentTurnPlayers() {
        var _this__experimentalCurrentState;
        var _this__experimentalCurrentState_currentTurnPlayers;
        return (_this__experimentalCurrentState_currentTurnPlayers = (_this__experimentalCurrentState = this._experimentalCurrentState) === null || _this__experimentalCurrentState === void 0 ? void 0 : _this__experimentalCurrentState.currentTurnPlayers) !== null && _this__experimentalCurrentState_currentTurnPlayers !== void 0 ? _this__experimentalCurrentState_currentTurnPlayers : [
            this._currentState.currentTurnPlayerColor
        ];
    }
    get nextPlayerToMoveRobber() {
        var _this__mechanicRobberColonistRushState;
        var _this__mechanicRobberColonistRushState_playerToMoveRobberOnNextSevenRoll;
        return (_this__mechanicRobberColonistRushState_playerToMoveRobberOnNextSevenRoll = (_this__mechanicRobberColonistRushState = this._mechanicRobberColonistRushState) === null || _this__mechanicRobberColonistRushState === void 0 ? void 0 : _this__mechanicRobberColonistRushState.playerToMoveRobberOnNextSevenRoll) !== null && _this__mechanicRobberColonistRushState_playerToMoveRobberOnNextSevenRoll !== void 0 ? _this__mechanicRobberColonistRushState_playerToMoveRobberOnNextSevenRoll : undefined;
    }
    get currentActivePlayers() {
        if (this._mechanicTurnColonistRushState) {
            const playersDiscardingCards = this.currentTurnPlayers.filter((playerColor)=>this.getPlayerActionState(playerColor) == ActionState.SelectCardsToDiscard);
            if (playersDiscardingCards.length > 0) return playersDiscardingCards;
            const playersToggledEndTurn = this.playersToggledEndTurn;
            const playersActive = this.currentTurnPlayers.filter((playerColor)=>!playersToggledEndTurn.includes(playerColor));
            return playersActive;
        } else {
            return this.currentTurnPlayers;
        }
    }
    get playersToggledEndTurn() {
        var _this__mechanicTurnColonistRushState;
        const playersToggledEndTurn = (_this__mechanicTurnColonistRushState = this._mechanicTurnColonistRushState) === null || _this__mechanicTurnColonistRushState === void 0 ? void 0 : _this__mechanicTurnColonistRushState.playersToggledEndTurn;
        if (playersToggledEndTurn == undefined) return [];
        return Object.keys(playersToggledEndTurn).map((key)=>parseInt(key, 10));
    }
    // WARNING! This architecture is fragile. This only works because the base game is force setting actionState until the refactor is
    // done. This is silently coupled to CurrentStateControllerDefault.setPlayerActionState
    getPlayerActionState(playerColor) {
        var _this__playerStates_playerColor, _this__playerStates;
        var _this__playerStates_playerColor_actionState;
        return (_this__playerStates_playerColor_actionState = (_this__playerStates = this._playerStates) === null || _this__playerStates === void 0 ? void 0 : (_this__playerStates_playerColor = _this__playerStates[playerColor]) === null || _this__playerStates_playerColor === void 0 ? void 0 : _this__playerStates_playerColor.actionState) !== null && _this__playerStates_playerColor_actionState !== void 0 ? _this__playerStates_playerColor_actionState : this._currentState.actionState;
    }
    hasPlayerToggledEndTurn(playerColor) {
        return this.playersToggledEndTurn.includes(playerColor);
    }
    isSomePlayerInActionState(actionState) {
        return this._playerColors.some((playerColor)=>this.getPlayerActionState(playerColor) === actionState);
    }
    areAllPlayersInActionState(actionState) {
        return this._playerColors.every((playerColor)=>this.getPlayerActionState(playerColor) === actionState);
    }
    getPlayersInActionState(actionState) {
        return this._playerColors.filter((playerColor)=>this.getPlayerActionState(playerColor) === actionState);
    }
    isOpponentInKnightBlockingState(player) {
        const blockerActionStates = [
            ActionState.PlaceRobberOrPirate,
            ActionState.PlaceRobberOnly,
            ActionState.PlacePirateOnly,
            ActionState.SelectWhoToRob
        ];
        return this._playerColors.some((playerColor)=>{
            if (playerColor === player) return false;
            return blockerActionStates.includes(this.getPlayerActionState(playerColor));
        });
    }
    constructor(currentState, experimentalCurrentState, mechanicTurnColonistRushState, playerStates, playerColors, mechanicRobberColonistRushState){
        this._currentState = currentState;
        this._experimentalCurrentState = experimentalCurrentState;
        this._mechanicTurnColonistRushState = mechanicTurnColonistRushState;
        this._mechanicRobberColonistRushState = mechanicRobberColonistRushState;
        this._playerStates = playerStates;
        this._playerColors = playerColors;
    }
}
